export default __webpack_public_path__ + "static/media/IBMApplication.6b924098.svg";